import React from 'react';
import styled from 'styled-components';
import { Table } from 'rbx';
import gql from 'graphql-tag';
import swal from 'sweetalert';

import { useMutation } from '@apollo/react-hooks';
import { useStoreState } from 'easy-peasy';
import { isNil } from 'lodash';
import { toast } from 'react-toastify';

import { Table as CustomTable, Box } from '../../../components/elements';

import List from './List';
import AddEditForm from './AddEditForm';
import client from '../../../utils/apolloClient';

const Container = styled.div`
  .table-container {
    min-height: 30rem;
  }
`;

const createCmsDataMutation = gql`
  mutation createCmsDataMutation($input: CreateCmsDataInput) {
    create_cms_data(input: $input) {
      error {
        code
        description
      }
    }
  }
`;

const updateCmsDataMutation = gql`
  mutation UpdateCmsDataMutation($input: UpdateCmsDataInput) {
    update_cms_data(input: $input) {
      error {
        code
        description
      }
    }
  }
`;

const deleteCmsDataMutation = gql`
  mutation deleteCmsDataMutation($input: DeleteCmsDataInput) {
    delete_cms_data(input: $input) {
      error {
        code
        description
      }
    }
  }
`;

const Details = ({ cmsData, activeModalProp, refetch }) => {
  const { userId } = useStoreState(state => state.auth);

  const {
    selectedCmsData,
    setSelectedCmsData,
    isActiveModal,
    setIsActiveModal,
  } = activeModalProp;

  const [createCmsData, { loading }] = useMutation(createCmsDataMutation, {
    client: client.clientPrivate,
    onCompleted: ({ create_cms_data }) => {
      if (!isNil(create_cms_data.error)) {
        create_cms_data.error.map(item => toast.error(item.description));
      } else {
        swal('Successfully added cms data!').then(() => {
          setIsActiveModal(false);
          refetch();
        });
      }
    },
  });

  const [updateCmsData, { loading: loading2 }] = useMutation(
    updateCmsDataMutation,
    {
      client: client.clientPrivate,
      onCompleted: ({ update_cms_data }) => {
        if (!isNil(update_cms_data.error)) {
          update_cms_data.error.map(item => toast.error(item.description));
        } else {
          swal('Successfully updated cms data!').then(() => {
            setIsActiveModal(false);
            refetch();
            setSelectedCmsData(null);
          });
        }
      },
    },
  );

  const [deleteCmsData, { loading: isDeleting }] = useMutation(
    deleteCmsDataMutation,
    {
      client: client.clientPrivate,
      onCompleted: ({ delete_cms_data }) => {
        if (!isNil(delete_cms_data.error)) {
          delete_cms_data.error.map(item => toast.error(item.description));
        } else {
          swal('Successfully deleted cms data!').then(() => {
            refetch();
            setSelectedCmsData(null);
          });
        }
      },
    },
  );

  return (
    <React.Fragment>
      <Box>
        <Container>
          <CustomTable>
            <Table.Head>
              <Table.Row>
                <Table.Heading>Name</Table.Heading>
                <Table.Heading>Description</Table.Heading>
                <Table.Heading>Type</Table.Heading>
                <Table.Heading>Actions</Table.Heading>
              </Table.Row>
            </Table.Head>
            <Table.Body>
              <List
                cmsData={cmsData}
                onEdit={value => {
                  setSelectedCmsData(value);
                  setIsActiveModal(true);
                }}
                onDelete={async value => {
                  deleteCmsData({
                    variables: {
                      input: {
                        id: value?.id,
                        user_id: userId,
                      },
                    },
                  });
                }}
                isDeleting={isDeleting}
              />
            </Table.Body>
          </CustomTable>
        </Container>
      </Box>
      {isActiveModal && (
        <AddEditForm
          cmsData={selectedCmsData}
          loading={loading || loading2}
          isActive={isActiveModal}
          onClose={() => setIsActiveModal(false)}
          onSubmit={values => {
            if (selectedCmsData) {
              updateCmsData({
                variables: {
                  input: {
                    id: selectedCmsData?.id,
                    user_id: userId,
                    name: values.name,
                    description: values.description,
                    cms_data_type: values.cms_data_type,
                  },
                },
              });
            } else {
              createCmsData({
                variables: {
                  input: {
                    user_id: userId,
                    name: values.name,
                    description: values.description,
                    cms_data_type: values.cms_data_type,
                  },
                },
              });
            }
          }}
        />
      )}
    </React.Fragment>
  );
};

export default Details;
